import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface SubscriptionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  isAdmin: boolean;
}

const SubscriptionExpiredModal: React.FC<SubscriptionExpiredModalProps> = ({ isOpen, onClose, isAdmin }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/settings/plans');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Subscription Expired</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Your subscription has expired
          </Alert>
          
          <Typography variant="body1" gutterBottom>
            Your subscription has been cancelled and the period has ended.
          </Typography>
          
          <Paper sx={{ bgcolor: 'background.default', p: 2, borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" paragraph>
              You can still view your existing simulations, but you'll need to resubscribe to create new ones.
            </Typography>
            
            <Typography variant="body2" color="text.secondary">
              Choose from one of our plans to continue using all features and creating new simulations.
            </Typography>
          </Paper>
        </Box>
      </DialogContent>
      
      <DialogActions>
        {isAdmin ? (
          <>
            <Button onClick={onClose} color="inherit">
              Not Now
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={handleUpgrade}
            >
              View Plans & Resubscribe
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onClose} color="inherit">
              Close
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => window.location.href = '/dashboard'}
            >
              Return to Dashboard
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionExpiredModal; 